// extracted by mini-css-extract-plugin
module.exports = {"shipmentTracking":"EF","header":"FF","orderId":"GF","divider":"HF","trackingError":"IF"};